import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
  header: {
    color: palette.black.main,
    lineHeight: spacing(0.15),
    fontSize: spacing(6),

    fontWeight: 'bold',
  },

  title: {
    color: palette.gray.main,
    lineHeight: spacing(0.15),
    fontSize: spacing(3.25),

    fontWeight: 'bold',
  },

  subtitle: {
    color: palette.black.main,
    lineHeight: spacing(0.2),
    fontSize: spacing(3.25),

    fontWeight: 'bold',
  },
  description: {
    color: palette.scorpionGray.light,
    lineHeight: spacing(0.2),
    fontSize: spacing(2),
    fontFamily: 'Roboto',
    letterSpacing: spacing(0.05),
    marginTop: spacing(1.625),
  },
  descriptionemail: {
    color: palette.scorpionGray.light,
    lineHeight: spacing(0.2),
    fontSize: spacing(2),
    fontFamily: 'Roboto',
    letterSpacing: spacing(0.05),
    width: '100%',
    textAlign: 'center',
  },
  label: {
    fontSize: spacing(2),
    fontFamily: 'Roboto',
    float: 'left',
    marginLeft: spacing(1.5),
  },
  TextField: {
    height: spacing(0.5),
    float: 'left',
    marginLeft: spacing(1.5),
  },

  buttonLabel: {
    backgroundColor: palette.blue.light,
    color: palette.white.main,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: spacing(2),
    margin: 'auto',
    marginTop: spacing(5),
    textTransform: 'initial',
    borderRadius: spacing(0.5),
    height: spacing(5),
  },

  column1: {
    marginTop: spacing(3.75),
  },

  card: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: spacing(3),
    width: spacing(48.5),
    height: spacing(50.375),
    boxShadow: ` ${spacing(0, 0.5, 1, 0)}  ${palette.info.main}`,
    [breakpoints.down('sm')]: {
      width: spacing(48.5),
      marginTop: spacing(3),
    },
    [breakpoints.down('xs')]: {
      width: '90vw',
      marginTop: spacing(3),
    },
  },
}));
